import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export default function DemoAnalyticsBanner() {
  return (
    <section className="rounded-3xl border border-amber-200 bg-amber-50/90 px-6 py-5 text-amber-900 shadow-[0_10px_24px_rgba(180,83,9,0.08)]">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Info size={20} className="mt-0.5 shrink-0 text-amber-600" />
          <div>
            <p className="text-sm font-semibold">Отображаются демонстрационные данные</p>
            <p className="mt-1 text-sm text-amber-800">
              Добавьте собственные объекты размещения, чтобы отслеживать их аналитику.
            </p>
          </div>
        </div>
        <Link
          to="/my/objects"
          className="inline-flex shrink-0 items-center justify-center rounded-full border border-amber-300 bg-white px-4 py-2 text-xs font-semibold text-amber-800 transition hover:bg-amber-100"
        >
          Мои объекты
        </Link>
      </div>
    </section>
  );
}
